var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pixPriceProduct)?_c('discount-pix',[_vm._v("\n    no PIX por "),_c('span',[_vm._v(_vm._s(_vm.pixPriceProduct))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }